import {
  jb_info_page_hero_css_default
} from "./chunk.L7GZNXKW.js";
import {
  Spaceable
} from "./chunk.LK5OUX7S.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-info-page-hero/jb-info-page-hero.ts
var JbInfoPageHero = class extends Spaceable(r) {
  _getContentSpacingProperties() {
    return { colsMdUp: 10, type: "no-vertical-space" };
  }
  render() {
    return ke`
      <div>
        <slot></slot>
        ${this.header ? ke`<h1>${this.header}</h1>` : D}
        ${this.subheader ? ke`<p>${this.subheader}</p>` : D}
      </div>
    `;
  }
};
JbInfoPageHero.styles = jb_info_page_hero_css_default;
__decorateClass([
  n()
], JbInfoPageHero.prototype, "header", 2);
__decorateClass([
  n()
], JbInfoPageHero.prototype, "subheader", 2);
JbInfoPageHero = __decorateClass([
  customElement("jb-info-page-hero")
], JbInfoPageHero);

export {
  JbInfoPageHero
};
